import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { toNaira } from 'src/utils/helper';
import formatPrice from 'src/utils/formatPrice';
import TripStatus from './TripStatus';

const useStyles = makeStyles(() => ({
  nowrap: {
    whiteSpace: 'nowrap'
  }
}));

export default function BookingRow({ booking, hover, ...props }) {
  const classes = useStyles();
  return (
    <TableRow
      hover={hover}
      style={{ cursor: hover ? 'pointer' : 'auto' }}
      {...props}
    >

      <TableCell>{booking.departureText}</TableCell>
      <TableCell>{booking.destinationText}</TableCell>
      <TableCell className={classes.nowrap}>
        {formatPrice(booking.amount, booking.pricingCurrency, toNaira)}
      </TableCell>
      <TableCell>{booking.paymentStatus}</TableCell>
      <TableCell size="smalls">
        <TripStatus status={booking.bookingStatus} />
      </TableCell>
      <TableCell>{booking.departureDate}</TableCell>
      <TableCell>{booking.departureTime}</TableCell>
      <TableCell>{moment(booking.createdAt).format("DD MMM YYYY")}</TableCell>
    </TableRow>
  );
}

BookingRow.propTypes = {
  booking: PropTypes.object.isRequired,
  hover: PropTypes.bool
};
